const OrderStatus = {
  Processing: "processing",
  ForApproval: "for-approval",
  ForRevision: "for-revision",
  Canceled: "canceled",
  Rejected: "rejected",
  ForDelivery: "for-delivery",
  Delivered: "delivered",
  Pending: "pending",
};

export default OrderStatus;
